var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#31B7A9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44531 12.0632C9.44531 11.7501 9.61505 11.4616 9.88872 11.3096L15.9231 7.95712C16.1835 7.81247 16.5001 7.81247 16.7605 7.95712L22.7949 11.3096C23.0686 11.4616 23.2383 11.7501 23.2383 12.0632V16.062C23.2383 19.1927 21.541 22.0773 18.8042 23.5977L16.7605 24.7332C16.5001 24.8778 16.1835 24.8778 15.9231 24.7332L13.8794 23.5977C11.1426 22.0773 9.44531 19.1927 9.44531 16.062V12.0632Z",
    fill: "#31B7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationPending);
export default __webpack_public_path__ + "static/media/verification-pending.9e046c6a8b11624ce0c6a86c61ad584e.svg";
export { ForwardRef as ReactComponent };